export default "__VITE_PUBLIC_ASSET__c9aa542b__"